export default __webpack_public_path__ + "static/media/Icon13_On.1f9e6aeb.png";